// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableWrapper[data-v-adffebb6]{margin-top:30px;padding:0 20px}.margin-b-20[data-v-adffebb6]{margin-bottom:20px}.margin-r-8[data-v-adffebb6]{margin-right:8px}.width-300[data-v-adffebb6]{width:300px}", ""]);
// Exports
module.exports = exports;
